module.exports = __webpack_public_path__ + "img/time-left-placeholder.90f1c7cd.svg";